import React, {useCallback, useState, useEffect} from 'react'
import app from './App.module.scss'
import Main from '../../pages/Main/Main'
import Header  from '../Header/Header'
import Footer  from '../Footer/Footer'
import UpButton from '../UpButton/UpButton'
import Modal from '../../components/Modal/Modal'
import PrivacyPolicy from '../../components/PrivacyPolicy/PrivacyPolicy'
import ModalForm from '../ModalForm/ModalForm'

function App() {

  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [isPopupPrivacyPolicyOpen, setIsPopupPrivacyPolicyOpen] = useState(false)
  const [isPopupFormOpen, setIsPopupFormOpen] = useState(false)
  const [scrollProgress, setScrollProgress] = useState(0);


  const vh = window.innerHeight / 100;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // Параллакс эффект
    useEffect(() => {
      const handleScroll = () => {
        const scrolled = window.pageYOffset;
        setScrollProgress((scrolled / (document.body.scrollHeight - window.innerHeight)) * 100);
      };
  
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);


  const handleFormOpen = useCallback(() => {
    setIsPopupFormOpen(true)
  }, []);

  const handleFormClose = useCallback(() => {
    setIsPopupFormOpen(false)
  }, []);

  const handleOpen = useCallback(() => {
    setIsPopupOpen(true)
  }, []);

  const handleClose = useCallback(() => {
    setIsPopupOpen(false)
  }, []);

  const handlePrivacyPolicyClose = useCallback(() => {
    setIsPopupPrivacyPolicyOpen(false)
  }, []);

  const handlePrivacyPolicyOpen = useCallback(() => {
    setIsPopupPrivacyPolicyOpen(true)
  }, [])



  return (
    <div className={app.page}>
      <div className={app.scroll_progress} style={{ width: `${scrollProgress}%` }}></div>
      <Header
      />
      <Main
        isOpen={handleFormOpen}
        popupOpen={handleOpen}
        isPrivacyPolicyOpenOpen={handlePrivacyPolicyOpen}
      />
      <Footer
        isOpen={handlePrivacyPolicyOpen}
      />  
      <UpButton/>
      {isPopupOpen && 
      <Modal
        onClose={handleClose}
      />}
      {isPopupPrivacyPolicyOpen && 
      <PrivacyPolicy
        onClose={handlePrivacyPolicyClose}
      />}
      {isPopupFormOpen && 
      <ModalForm
        onClose={handleFormClose}
        popupOpen={handleOpen}
        isPrivacyPolicyOpenOpen={handlePrivacyPolicyOpen}
      ></ModalForm>}
    </div>
  );
}

export default App;
